import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e0fed90"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "menu-container" }
const _hoisted_3 = ["id", "onClick"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "menu-name" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 새로운 그룹을 생성합니다! 🎉 ", -1))
const _hoisted_7 = { class: "menu-name-detail detail" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 메뉴를 선택하셨어요!")

import Modal from "@/components/Modal.vue";
import AddMenuBtn from "@/views/home/menu-list/components/AddMenuBtn.vue";
import GetRandomMenuBtn from "@/views/home/menu-list/components/GetRandomMenuBtn.vue";
import { Timestamp } from "@firebase/firestore";
import { ListType, TListType } from "../types";
import { IMenu } from "@/app/menu/types";
import { useStore } from "vuex";
import useModal from "@/hooks/useModal";
import {
  computed,
  onMounted,
  reactive,
  toRefs,
} from "vue";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  props: {
    menus: null
  },
  emits: ["setListType"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: "setListType", event: TListType): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  menus: IMenu[];
}

const store = useStore();
const router = useRouter();
const { isModalOpen, closeModal } = useModal();





onMounted(() => {
  const isRoutedByGroupId = router.currentRoute.value.params.id ? true : false;

  if (!isRoutedByGroupId) return;
  emits("setListType", ListType.Groups);
});

const { menus } = toRefs(props);

const state = reactive({
  clickedMenuId: "",
});

function setIsModalOpen(event: Event, isOpen: boolean, menuId: string) {
  state.clickedMenuId = menuId;
  isModalOpen.value = isOpen;
}

function createGroup() {
  const currentUser = store.getters["UserStore/getCurrentUser"];
  const currentUserId = currentUser.uid;

  const newGroup = {
    createdAt: Timestamp.now(),
    menu: state.clickedMenuId,
    users: [currentUserId],
    lead: currentUserId,
  };
  store.dispatch("GroupStore/createGroupAsync", newGroup);
  isModalOpen.value = false;
  emits("setListType", ListType.Groups);
}

const clickedMenu = computed(() => {
  return menus.value.find((menu: IMenu) => menu.id === state.clickedMenuId);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menus), (menu) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "menu-item",
          key: menu.id,
          id: menu.id,
          onClick: ($event: any) => (setIsModalOpen($event, true, menu.id))
        }, [
          _createElementVNode("img", {
            class: "menu-image",
            src: menu.imgSrc,
            loading: "lazy"
          }, null, 8, _hoisted_4),
          _createElementVNode("span", _hoisted_5, _toDisplayString(menu.name), 1)
        ], 8, _hoisted_3))
      }), 128))
    ]),
    _createElementVNode("footer", null, [
      _createVNode(GetRandomMenuBtn),
      _createVNode(AddMenuBtn)
    ]),
    (_unref(isModalOpen))
      ? (_openBlock(), _createBlock(Modal, { key: 0 }, {
          header: _withCtx(() => [
            _hoisted_6
          ]),
          body: _withCtx(() => [
            _createElementVNode("span", null, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(clickedMenu).name), 1),
              _hoisted_8
            ])
          ]),
          "footer-yes-button": _withCtx(() => [
            _createElementVNode("button", {
              type: "text",
              onClick: createGroup
            }, "네!")
          ]),
          "footer-close-button": _withCtx(() => [
            _createElementVNode("button", {
              type: "text",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(closeModal) && _unref(closeModal)(...args)))
            }, "다음에 만들게요")
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})